import { render, staticRenderFns } from "./LoginsReports.vue?vue&type=template&id=aefa4ff8"
import script from "./LoginsReports.vue?vue&type=script&lang=js"
export * from "./LoginsReports.vue?vue&type=script&lang=js"
import style0 from "./LoginsReports.vue?vue&type=style&index=0&id=aefa4ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports